import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'dematral_sidebar_collapsed';

@Injectable({
  providedIn: 'root'
})
export class SidebarCollapseService {
  private collapsedSubject = new BehaviorSubject<boolean>(this.chargerDepuisStorage());
  collapsed$ = this.collapsedSubject.asObservable();

  constructor() {}

  get collapsed(): boolean {
    return this.collapsedSubject.value;
  }

  toggle(): void {
    const next = !this.collapsedSubject.value;
    this.collapsedSubject.next(next);
    try {
      localStorage.setItem(STORAGE_KEY, String(next));
    } catch {}
    document.body.classList.toggle('sidebar-collapsed', next);
  }

  setCollapsed(value: boolean): void {
    this.collapsedSubject.next(value);
    try {
      localStorage.setItem(STORAGE_KEY, String(value));
    } catch {}
    document.body.classList.toggle('sidebar-collapsed', value);
  }

  private chargerDepuisStorage(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  }
}
